module.exports = __webpack_public_path__ + "static/img/fish49.57593b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish49.png
// module id = Driq
// module chunks = 0